import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const NumberedProducts = () => {
    return (
        <div className="numbered-products-wrapper xmt-16 xmt-lg-20">
            <div className="container">
                <div className="nav-link-numbered-products xmb-6">
                    <div className="title-numbered-products">
                        <ul className="nav nav-tabs" id="myTab" role="tab-b">
                            <li className="nav-item" role="presentation">
                                <h2 className="nav-link active" id="nav-numbered-products-tab"
                                   data-bs-toggle="tab"
                                   data-bs-target="#nav-numbered-products" role="tab"
                                   aria-controls="nav-numbered-products" aria-selected="true">
                                    پرفروش ها
                                </h2>
                            </li>
                            <li className="nav-item" role="presentation">
                                <h2 className="nav-link" id="nav-most-visited-tab"
                                   data-bs-toggle="tab"
                                   data-bs-target="#nav-most-visited" role="tab"
                                   aria-controls="nav-most-visited" aria-selected="true">
                                    پربازدیدترین ها
                                </h2>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="best-box position-relative">
                    <div className="numbered-products-box tab-pane fade show active" id="nav-numbered-products"
                         role="tabpanel" aria-labelledby="nav-numbered-products-tab">
                        <div className="more-numbered-products position-absolute">
                            <span className="d-none d-sm-inline"><a href="#">بیشتر</a></span>
                            <a href="#"><IconName name="chevron_left" className="icon"/></a>
                        </div>
                        <div className="swiper numbered-products-swiper xpr-8">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            style={{zIndex:100}}
                                            className="numbered-products-box-product d-flex justify-content-center align-items-center flex-column first-number">
                                            <div className="img-numbered-products">
                                                <div className="number-numbered-products position-absolute">1</div>
                                                <img src="./assets/sample-image/NOKIA-6.2-DS--64-GB--Ceramic-Black.png"
                                                     className="img-fluid" alt="nokia"/>
                                            </div>
                                            <div className="text-numbered-products xmt-1 xmt-md-4">
                                                <h3>پایه شارژ گوشی موبایل اپل آیفون</h3>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            style={{zIndex:99}}
                                            className="numbered-products-box-product d-flex justify-content-center align-items-center flex-column">
                                            <div className="img-numbered-products">
                                                <div className="number-numbered-products position-absolute">2</div>
                                                <img
                                                    src="./assets/sample-image/XIAOMI-XM200001-Mi-Smart-Kettel--Wasserkocher--Wei.png"
                                                    className="img-fluid" alt="nokia"/>
                                            </div>
                                            <div className="text-numbered-products xmt-1 xmt-md-4">
                                                <h3>کتری هوشمند شیائومی XM200001</h3>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            style={{zIndex:98}}
                                            className="numbered-products-box-product d-flex justify-content-center align-items-center flex-column">
                                            <div className="img-numbered-products">
                                                <div className="number-numbered-products position-absolute">3</div>
                                                <img src="./assets/sample-image/6535256_thumb.png"
                                                     className="img-fluid" alt="nokia"/>
                                            </div>
                                            <div className="text-numbered-products xmt-1 xmt-md-4">
                                                <h3>هدفون بی‌سیم بیتس مدل
                                                    Studio 3 – The Beats Skyline Collection</h3>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            style={{zIndex:97}}
                                            className="numbered-products-box-product d-flex justify-content-center align-items-center flex-column">
                                            <div className="img-numbered-products">
                                                <div className="number-numbered-products position-absolute">4</div>
                                                <img
                                                    src="./assets/sample-image/XIAOMI-Roborock-S50-Vacuum-Cleaner-Saugroboter--Rund--Wei.png"
                                                    className="img-fluid" alt="nokia"/>
                                            </div>
                                            <div className="text-numbered-products xmt-1 xmt-md-4">
                                                <h3>جارو برقی رباتیک هوشمند نسخه 2 شیائومی</h3>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            style={{zIndex:96}}
                                            className="numbered-products-box-product d-flex justify-content-center align-items-center flex-column">
                                            <div className="img-numbered-products">
                                                <div className="number-numbered-products position-absolute">5</div>
                                                <img src="./assets/sample-image/NOKIA-6.2-DS--64-GB--Ceramic-Black.png"
                                                     className="img-fluid" alt="nokia"/>
                                            </div>
                                            <div className="text-numbered-products xmt-1 xmt-md-4">
                                                <h3>پایه شارژ گوشی موبایل اپل آیفون</h3>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="numbered-products-box tab-pane fade" id="nav-most-visited"
                         role="tabpanel" aria-labelledby="nav-most-visited-tab">
                        <div className="more-numbered-products position-absolute best-visited">
                            <span className="d-none d-sm-inline"><a href="#">بیشتر</a></span>
                            <a href="#"><IconName name="chevron_left" className="icon"/></a>
                        </div>
                        <div className="swiper numbered-products-visited-swiper xpr-8">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            style={{zIndex:100}}
                                            className="numbered-products-box-product d-flex justify-content-center align-items-center flex-column first-number">
                                            <div className="img-numbered-products">
                                                <div className="number-numbered-products position-absolute">1</div>
                                                <img src="./assets/sample-image/NOKIA-6.2-DS--64-GB--Ceramic-Black.png"
                                                     className="img-fluid" alt="nokia"/>
                                            </div>
                                            <div className="text-numbered-products xmt-1 xmt-md-4">
                                                <h3>پایه شارژ گوشی موبایل اپل آیفون</h3>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            style={{zIndex:99}}
                                            className="numbered-products-box-product d-flex justify-content-center align-items-center flex-column">
                                            <div className="img-numbered-products">
                                                <div className="number-numbered-products position-absolute">2</div>
                                                <img
                                                    src="./assets/sample-image/XIAOMI-XM200001-Mi-Smart-Kettel--Wasserkocher--Wei.png"
                                                    className="img-fluid" alt="nokia"/>
                                            </div>
                                            <div className="text-numbered-products xmt-1 xmt-md-4">
                                                <h3>کتری هوشمند شیائومی XM200001</h3>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            style={{zIndex:98}}
                                            className="numbered-products-box-product d-flex justify-content-center align-items-center flex-column">
                                            <div className="img-numbered-products">
                                                <div className="number-numbered-products position-absolute">3</div>
                                                <img src="./assets/sample-image/6535256_thumb.png"
                                                     className="img-fluid" alt="nokia"/>
                                            </div>
                                            <div className="text-numbered-products xmt-1 xmt-md-4">
                                                <h3>هدفون بی‌سیم بیتس مدل
                                                    Studio 3 – The Beats Skyline Collection</h3>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            style={{zIndex:97}}
                                            className="numbered-products-box-product d-flex justify-content-center align-items-center flex-column">
                                            <div className="img-numbered-products">
                                                <div className="number-numbered-products position-absolute">4</div>
                                                <img
                                                    src="./assets/sample-image/XIAOMI-Roborock-S50-Vacuum-Cleaner-Saugroboter--Rund--Wei.png"
                                                    className="img-fluid" alt="nokia"/>
                                            </div>
                                            <div className="text-numbered-products xmt-1 xmt-md-4">
                                                <h3>جارو برقی رباتیک هوشمند نسخه 2 شیائومی</h3>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="swiper-slide">
                                    <a href="#">
                                        <div
                                            style={{zIndex:96}}
                                            className="numbered-products-box-product d-flex justify-content-center align-items-center flex-column">
                                            <div className="img-numbered-products">
                                                <div className="number-numbered-products position-absolute">5</div>
                                                <img src="./assets/sample-image/NOKIA-6.2-DS--64-GB--Ceramic-Black.png"
                                                     className="img-fluid" alt="nokia"/>
                                            </div>
                                            <div className="text-numbered-products xmt-1 xmt-md-4">
                                                <h3>پایه شارژ گوشی موبایل اپل آیفون</h3>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NumberedProducts;
